import {
  Accordion,
  AccordionButton,
  Text,
  AccordionIcon,
  AccordionPanel,
  Box,
  AccordionItem,
  Center,
  Container,
} from "@chakra-ui/react";
import React from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { Helmet } from "react-helmet";
import api from "../../utils/ApiMethod";
// import AccordionItem from "react-bootstrap/esm/AccordionItem";

const EventOrg2 = () => {
  const [events, setEvents] = React.useState([]);
  React.useEffect(() => {
    const handleFetchData = async () => {
      try {
        // fetch from /data/events-log.json
        const data = await api.fetchData("/events-log");
        //   filter those whose eventDate exceeds today
        // sort by item.eventDate
        setEvents(
          data
            .filter((item) => new Date(item.eventDate) < new Date())
            .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate)),
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    handleFetchData();
  }, []);

  return (
    <div
    // style={{ backgroundImage: 'linear-gradient(to bottom, #0a3272, white)' }}
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>Sports Events Organized | Sports Championships | BSSA</title>
        <meta
          name="description"
          content="बिहार राज्य खेल प्राधिकरण की आयोजन और संगठन पेज: इस पेज पर विभिन्न खेल आयोजनों और संबंधित गतिविधियों के आयोजन की जानकारी उपलब्ध है। यह पेज खेल से जुड़े कार्यक्रमों के बारे में विस्तृत जानकारी प्रदान करता है।"
        />
      </Helmet>

      {/* transform accordion based on events, use events.map, use item.eventName for accordion button, item.eventDescription for acoordion panel, sort by eventDate*/}

      <Center p={6} m={6} flexDirection="column" w="100%">
        {/* Header – full width */}
        <Box boxShadow="lg" p="1" rounded="md" bg="#c0c9d0" mb={4} w="100%">
          <Text
            fontWeight="bold"
            textTransform="uppercase"
            fontSize={["18", "24"]}
            letterSpacing="wide"
            color="#fcffff"
            py={2}
            backgroundColor="#0b2651"
            textAlign="center"
            borderRadius="15px"
          >
            आयोजित कार्यक्रम
          </Text>
        </Box>

        {/* Accordion container – full width, with internal padding */}
        <Accordion defaultIndex={[0]} allowToggle w="100%">
          <Box
            bg="#0b244d"
            px={3} /* padding instead of margin */
            borderBottomLeftRadius={25}
            borderBottomRightRadius={25}
            w="100%"
          >
            {(events||[]).map((item, index) => (
              <AccordionItem key={index}>
                <h1>
                  <AccordionButton>
                    <Box
                      as="span"
                      flex="1"
                      textAlign="left"
                      fontSize={["16", "18"]}
                      color="#f6ffff"
                      p="3"
                    >
                      {item?.eventName || ""}
                    </Box>
                    <AccordionIcon color="#f6ffff" fontSize={25} />
                  </AccordionButton>
                </h1>
                <AccordionPanel
                  pb={4}
                  textAlign="left"
                  fontSize={["13", "18"]}
                  color="#f6ffff"
                >
                  <div
                    style={{ whiteSpace: "pre-wrap" }}
                    dangerouslySetInnerHTML={{
                      __html: item?.eventDescription || "",
                    }}
                  />
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Box>
        </Accordion>
      </Center>
    </div>
  );
};

export default EventOrg2;
